import { render } from "./StripeVision.vue?vue&type=template&id=4790b3a9"
import script from "./StripeVision.vue?vue&type=script&lang=js"
export * from "./StripeVision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__